














import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/individual';
import { PessoaFisicaFiltroParmDTO } from '@/interfaces/individuals';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';

@Component
export default class UiComboboxIndividual extends BaseComponent {
  @Prop()
  value: any;

  @Prop({ default: true })
  returnText: boolean;

  selected: any = null;
  searchInput = null;

  loading = false;
  list = [];

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.selected = v;
  }

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          //this.loading = true;
        }),
        switchMap((filter) => {
          return service.listIndividualsCombo(filter);
        })
      )
      .subscribe(
        (res) => {
          this.list = res;
          this.loading = false;
        },
        (error) => {
          this.showToastApiError(error);
          this.loading = false;
        }
      );
  }

  @Watch('searchInput')
  onSearchInputChange(s) {
    if (!s || s.length < 4) {
      return;
    }
    this.load();
  }

  load() {
    let parm = new PessoaFisicaFiltroParmDTO();
    parm.parteNome = this.searchInput;
    parm.medico = true;
    parm.usuario = true;
    this.execBehaviorSub$.next(parm);
  }

  onChange() {
    if (this.returnText && this.selected && this.selected.nome) {
      this.$emit('input', this.selected.nome);
      this.$emit('change', this.selected.nome);
    } else {
      this.$emit('input', this.selected);
      this.$emit('change', this.selected);
    }
  }
}
